export const PENDING_FAVORITE_ID_KEY = "vc_pending_favorite_id";
export const PENDING_SAVE_KEY = "vc_pending_save";

export function queuePendingFavoriteCrosshairId(id: number): void {
    sessionStorage.setItem(PENDING_FAVORITE_ID_KEY, String(id));
}

export function queuePendingSave(nameTrimmed: string): void {
    sessionStorage.setItem(PENDING_SAVE_KEY, JSON.stringify({ name: nameTrimmed }));
}
